import { useEffect, useState } from 'react'

import { CrosshairIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { ThemeToggle } from '@/components/theme-toggle'

import {
  HeroNavigation,
  HeroNavigationSmallScreen,
  type Navigation
} from '@/components/shadcn-studio/blocks/hero-section-40/hero-navigation'

import { cn } from '@/lib/utils'

type HeaderProps = {
  navigationData: Navigation[]
  className?: string
}

const Header = ({ navigationData, className }: HeaderProps) => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <header
      className={cn(
        'sticky top-0 z-50 h-16 w-full border-b px-4 transition-all duration-300 sm:px-6 lg:px-8',
        {
          'bg-card/75 shadow-md backdrop-blur': isScrolled
        },
        className
      )}
    >
      <div className='mx-auto flex h-full max-w-7xl items-center justify-between gap-4 border-x px-4 sm:px-6 lg:px-8'>
        {/* Logo */}
        <a href='/'>
          <div className='flex items-center gap-2.5'>
            <div className='bg-primary text-primary-foreground flex size-8 items-center justify-center rounded-md'>
              <CrosshairIcon className='size-5' />
            </div>
            <span className='text-lg font-semibold tracking-tight'>Prospect Hunter</span>
          </div>
        </a>

        {/* Navigation */}
        <HeroNavigation navigationData={navigationData} />

        {/* Actions */}
        <div className='flex items-center gap-3'>
          <ThemeToggle />
          <Button variant='outline' size='default' asChild className='hidden lg:inline-flex'>
            <a href='/login'>Log in</a>
          </Button>
          <Button size='default' asChild className='hidden lg:inline-flex'>
            <a href='/login?mode=signup'>Sign up</a>
          </Button>

          <HeroNavigationSmallScreen navigationData={navigationData} />
        </div>
      </div>
    </header>
  )
}

export default Header
